import React from 'react'


const triwulan = ["tw1", "tw2", "tw3", "tw4"]
const TableSakip = ({ dataTable = [], yearconfig = new Date().getFullYear(), loading = false }) => {
    return (
        <div className="w-full sm:overflow-visible overflow-x-auto flex flex-col justify-center">
            <table className="w-full table-auto text-xs mb-4">
                <thead className="bg-primeColor1 text-white sticky top-0">
                    <tr>
                        <th className="border border-slate-500  w-[3%]" rowSpan={3}>
                            No
                        </th>
                        <th className="border border-slate-500 md:w-1/4" rowSpan={3}>
                            Indikator
                        </th>
                        <th className="border border-slate-500 w-[10%]" rowSpan={3}>
                            Satuan
                        </th>
                        <th className="border border-slate-500" colSpan={triwulan.length * 3}>
                            Tahun {yearconfig}
                        </th>
                    </tr>
                    <tr>
                        {
                            triwulan.map((item, index) => {
                                return (
                                    <th className="border border-slate-500" colSpan={3}>
                                        <span className="md:block hidden">{`Triwulan ${index+1}`}</span>
                                        <span className="md:hidden block">{`Tw ${index+1}`}</span>
                                    </th>
                                )
                            })
                        }
                    </tr>
                    <tr>
                        {
                            triwulan.map((item, key) => {
                                return (
                                    <>
                                        <th className="border border-slate-500" key={key}>
                                            <span className="md:block hidden">Target</span>
                                            <span className="md:hidden block">T</span>
                                        </th>
                                        <th className="border border-slate-500">
                                            <span className="md:block hidden">Realisasi</span>
                                            <span className="md:hidden block">R</span>
                                        </th>
                                        <th className="border border-slate-500">
                                            <span className="md:block hidden">Capaian</span>
                                            <span className="md:hidden block">C</span>
                                        </th>
                                    </>
                                )
                            })
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        !loading ?  
                        dataTable.length > 0 ?renderSasaran(dataTable) 
                        :
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center" colSpan="100%">No Data</td>
                        </tr>
                        : 
                        <tr>
                            <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center" colSpan="100%">Loading...</td>
                        </tr>
                    }
                </tbody>
            </table>
            <span className="text-red-400 text-xs font-bold">
                Notes : <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; *) Data triwulan IV
            </span>
        </div>
    )
}
const renderSasaran = (data) =>{
    try {
        return (
            data.sasaran ? data.sasaran.map((item, keys) => {
                const indikator = renderIndikator(item.indikator)
                const sasaran = (
                    <>
                        <tr key={keys}>
                            <td className="border border-slate-500 font-bold py-2 px-5 bg-primeColor2" colSpan={15}>{item.nm_sasaran}</td>
                        </tr>
                        {
                            indikator
                        }
                    </>
                )
                return (sasaran)
            }) :
            <tr>
                <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center text-lg font-bold" colSpan={15}>{data.message}</td>
            </tr>
        )
        
    } catch (error) {
        return (
            <tr>
            <td className="border border-slate-500 py-2 px-5 bg-green-200 text-center text-lg font-bold" colSpan={15}>No Data</td>
        </tr>
        )
    }
}

const renderIndikator = (list) => {
    return list?.map((val, keys) => {
        return (
            <tr key={keys} className="odd:bg-secondaryColor2">
                <td className="border border-slate-500 p-2 text-center">{keys+1}</td>
                <td className="border border-slate-500 p-2">{val.nm_sasaran_indikator}</td>
                <td className="border border-slate-500 p-2 text-center"  dangerouslySetInnerHTML={{ __html: val.satuan }}></td>
                {
                    triwulan.map((item) => {
                        return (
                            <>
                                <td className="border border-slate-500 p-2 text-center">{val[`target_${item}`]}</td>
                                <td className="border border-slate-500 p-2 text-center">{val[`realisasi_${item}`]}</td>
                                <td className="border border-slate-500 p-2 text-center">{val[`capaian_${item}`]}</td>
                            </>
                        )
                    })
                }
            </tr>
        )
    })
}

export default TableSakip